<div #container class="scroll-container">
  <button
    #scrollHandleLeft
    class="scroll-container-button scroll-container-button-left border nordic-blue-900-border border-primary circle white-bg surface-primary elevation-level-1 ps-xxsmall"
    (click)="scrollLeft()"
    [tabindex]="disableKeyboardNavigation ? -1 : 0"
    data-testid="scroll-left-button"
  >
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_LEFT" />
  </button>

  <button
    #scrollHandleRight
    class="scroll-container-button scroll-container-button-right border nordic-blue-900-border border-primary circle white-bg surface-primary elevation-level-1 ps-xxsmall"
    (click)="scrollRight()"
    [tabindex]="disableKeyboardNavigation ? -1 : 0"
    data-testid="scroll-right-button"
  >
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_RIGHT" />
  </button>

  <ng-content />
</div>
